import Vue from 'vue'
import Router from 'vue-router'
import smallChat from '@/components/chat/smallChat'
import bigChat from '@/components/chat/bigChat'
import moveChat from '@/components/chat/moveChat'
import webLetterCard from '@/components/letter/webLetterCard'
import letterInput from '@/components/letter/letterInput'


import yqLink from '@/components/link/yqLink'
import moveLink from '@/components/link/moveLink'
import webLink from '@/components/link/webLink'
import moveLetter from '@/components/link/moveLetter'
import webLetter from '@/components/link/webLetter'
import icoShow from '@/components/common/icoShow'
import inviteChat from '@/components/common/inviteChat'
import floatNavigation from '@/components/common/plusIcon'





Vue.use(Router)

export default new Router({
  routes: [
    {path: '/smallChat',component: smallChat},
    {path: '/bigChat',component: bigChat},
    {path: '/webChat',component: bigChat},
    {path: '/moveChat',component: moveChat},
    {path: '/webLetterCard',component: webLetterCard},
    {path: '/letterInput',component: letterInput},
    {path: '/moveLink',component: moveLink},
    {path: '/webLink',component: webLink},
    {path: '/moveLetter',component: moveLetter},
    {path: '/webLetter',component: webLetter},
    {path: '/yqLink',component: yqLink},
    {path: '/icoShow',component: icoShow},
    {path: '/inviteChat',component: inviteChat},
    {path: '/floatNavigation',component: floatNavigation},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js